import React from 'react';
import PropTypes from 'prop-types';

const ReplyWrapper = ({ content }) => (<span className="string--reply">{content}</span>);

ReplyWrapper.propTypes = {
  content: PropTypes.oneOfType([PropTypes.instanceOf(Array)]).isRequired,
};

export default ReplyWrapper;
